"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// common/element/BarChartHorizontal.tsx
const react_1 = __importStar(require("react"));
const recharts_1 = require("recharts");
const styled_components_1 = __importDefault(require("styled-components"));
// Helper to generate N visually distinct colors (HSL)
const generateColors = (n) => Array.from({ length: n }, (_, i) => `hsl(${(i * 360) / n}, 70%, 60%)`);
// Helper to truncate text with ellipsis
const truncate = (str, maxLength) => str.length > maxLength ? str.slice(0, maxLength) + '…' : str;
// Custom tick renderer for XAxis
const renderTruncatedTick = (props) => {
    const { x, y, payload } = props;
    const maxLength = 12; // Set your max label length here
    const displayValue = truncate(payload.value, maxLength);
    return (react_1.default.createElement("text", { x: x, y: y + 10, textAnchor: "end", fontSize: 12, transform: `rotate(-45, ${x}, ${y})` }, displayValue));
};
const TriangleBar = (props) => {
    const { fill, x, y, width, height } = props;
    const triangleHeight = Math.min(16, height / 2); // triangle height (adjust as needed)
    return (react_1.default.createElement("g", null,
        react_1.default.createElement("rect", { x: x, y: y + triangleHeight, width: width, height: height - triangleHeight, fill: fill }),
        react_1.default.createElement("polygon", { points: `
                    ${x},${y + triangleHeight + 0.5}
                    ${x + width / 2},${y}
                    ${x + width},${y + triangleHeight + 0.5}
                `, fill: fill })));
};
const BarGraphContainer = styled_components_1.default.div `
    width: 100%;
    height: 420px;
	padding-right: 2px;
    overflow-x: auto;
    overflow-y: hidden;

    /* Remove focus border from SVG and its children */
    svg:focus,
    svg *:focus {
        outline: none !important;
        box-shadow: none !important;
    }
`;
const BarGraph = ({ data }) => {
    const barWidth = 40;
    const chartWidth = Math.max(data.length * barWidth + 60, 200);
    const colors = generateColors(data.length);
    const containerRef = (0, react_1.useRef)(null);
    const [parentWidth, setParentWidth] = (0, react_1.useState)(0);
    (0, react_1.useLayoutEffect)(() => {
        if (containerRef.current) {
            setParentWidth(containerRef.current.offsetWidth);
        }
    }, [data.length]);
    const responsiveWidth = chartWidth < parentWidth ? '100%' : chartWidth;
    return (react_1.default.createElement(BarGraphContainer, { ref: containerRef },
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: responsiveWidth, height: "100%" },
            react_1.default.createElement(recharts_1.BarChart, { data: data, margin: { top: 30, right: 20, left: 10, bottom: 40 }, barSize: 24, gap: 10 },
                react_1.default.createElement(recharts_1.XAxis, { dataKey: "value", type: "category", tick: renderTruncatedTick, interval: 0, angle: -45, textAnchor: "end", height: 60 }),
                react_1.default.createElement(recharts_1.YAxis, { type: "number", tick: { fontSize: 12 }, allowDecimals: false, domain: [0, 'dataMax'] }),
                react_1.default.createElement(recharts_1.Bar, { dataKey: "count", isAnimationActive: false, shape: react_1.default.createElement(TriangleBar, null) },
                    data.map((entry, index) => (react_1.default.createElement(recharts_1.Cell, { key: `cell-${index}`, fill: colors[index % colors.length] }))),
                    react_1.default.createElement(recharts_1.LabelList, { dataKey: "count", position: "top", style: { fontSize: 12, fill: '#222' } }))))));
};
exports.default = BarGraph;
